import { render } from "./generalCompanySettings.vue?vue&type=template&id=a5f2fc12"
import script from "./generalCompanySettings.vue?vue&type=script&lang=js"
export * from "./generalCompanySettings.vue?vue&type=script&lang=js"

import "./generalCompanySettings.vue?vue&type=style&index=0&id=a5f2fc12&scopped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__